import { memo } from "react";
import Page from "app/pages/.shared/Page/Page";
import { FormattedMessage } from "react-intl";
import "./CookiePolicy.scss";
import HeadMetadata from "app/utils/metas/HeadMetadata";

const CookiePolicy = () => (
	<Page title={<FormattedMessage id="menu.item.cookies.policy" />}>
		<HeadMetadata
			title="page.title.cookie.policy"
			description="page.description.cookie.policy"
		/>
		<div id="ot-sdk-cookie-policy" className="cookie-policy" />
	</Page>
);

export default memo(CookiePolicy);
